import { Component, OnInit, NgZone } from '@angular/core';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var $: any;

@Component({
  selector: 'app-qr-student-modal',
  templateUrl: './qr-student-modal.component.html',
  styleUrls: ['./qr-student-modal.component.scss']
})
export class QrStudentModalComponent implements OnInit {
  student;
  currLang;
  schoolName: string;
  schoolImage: string
  hoverFlag = false;
  cardType = 'single';
  privewCards = false;
  students = [];
  imageToPrint = [];
  pages = [];

  constructor(private qrControl: ControlQrService,
    private router: Router,
    private _ngZone: NgZone,
    private globalService: GlobalService,
    private translate: TranslateService,
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $(document).on('hidden.bs.modal', '#qrStudentModal', () => {
      this.cancelModalHandler();
    })

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.hoverFlag = false;
    this.schoolName = localStorage.getItem('schoolName');
    this.schoolImage = environment.img_url + localStorage.getItem('schoolImage');
    this.qrControl.getStudentData().subscribe((res: any) => {
      if (res.student !== undefined) {
        this.student = res.student;
        this.cardType = res.type;
      }
    })

    this.qrControl.getStudentsData().subscribe((res: any) => {
      if (res.noOfStudents !== undefined && res.type === 'multi') {
        this.students = res.noOfStudents;
        this.cardType = res.type;
      }
    })
  }

  showOverlay() {
    this.hoverFlag = true;
  }

  hideOverlay() {
    this.hoverFlag = false;
  }

  getQrImage() {
    if(this.student !== undefined){
      return environment.img_url + this.student.qr_code;
    } 
  }

  getQrImageMultiStudent(student) {
    let qr_code = student.qr_code;
    return environment.img_url + qr_code;
  }

  printQR() {
    this._ngZone.runOutsideAngular(() => {
      html2canvas(document.querySelector('#print-student-card'), { logging: true, allowTaint: false, useCORS: true }).then(canvas => {
        const imgData = canvas.toDataURL('image/jpeg', 1);
        const documentDefinition = this.getDocumentDefinition(imgData);
        pdfMake.createPdf(documentDefinition).print();
      });
    })
  }

  printMultiQR() {
    // debugger
    for (let i = 0; i < this.students.length; i++) {
      // debugger
      let id = `#print-card-more${i+1}`;
      // let test=document.querySelector(id);
      // debugger
      html2canvas(document.querySelector(id), { logging: true, allowTaint: false, useCORS: true }).then(canvas => {
        // debugger
        const imgData = canvas.toDataURL('image/jpeg', 1);
        this.imageToPrint.push(imgData);
        if (i == this.students.length - 1) {
          // debugger
          const documentDefinition = this.getDocumentDefinition2(this.imageToPrint);
          pdfMake.createPdf(documentDefinition).print();
        }
      });
      
    }
  }

  showCards() {
    this.privewCards = true;
  }

  getDocumentDefinition(imgData) {
    let qrContent =
      [
        {
          pageSize: 'A4',
          image: imgData,
          margin: [-25, -35, -25, -14],
          fit: [150, 300],
        }
      ]

    return {
      pageSize: 'A4',
      pageOrientation: 'Landscape',
      content: qrContent
    }
  }

  getDocumentDefinition2(imgData) {
    if (imgData.length == 1) {
      return {
        pageSize: 'A4',
        pageOrientation: 'Landscape',
        content: [
          {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            image: imgData[0],
            margin: [-25, -35, -25, -14],
            fit: [141.73, 255.12],
          },
        ]
      }
    } else {
      imgData.forEach(element => {
        let page = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          image: element,
          margin: [-25, -35, -25, -14],
          fit: [141.73, 255.12],
          pageBreak: 'after',
        }
        this.pages.push(page);
      });
      return {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: this.pages
      }
    }
  }
  cancelModalHandler() {
    this.hoverFlag = false;
    this.privewCards = false;
    this.students = [];
    this.pages = [];
    this.cardType = 'single';
    this.imageToPrint = [];
  }
}
